import request from '@/utils/request'

export function getOpenMarketInfo(agentId, entrRqstFomNo, opmkNo) {
    let params = {
        dealCd: agentId,
        entrRqstFomNo: entrRqstFomNo,
        opmkNo: opmkNo
    }
    return request({
        url: `/ococ/datacapture/openmarket/getFormInfo`,
        method: 'get',
        params
    })
}

export function getSamSungInfo(agentId, entrRqstFomNo, opmkNo, trmMdlCd, ppCd) {
    let params = {
        dealCd: agentId,
        entrRqstFomNo: entrRqstFomNo,
        opmkNo: opmkNo,
        trmMdlCd: trmMdlCd,
        ppCd: ppCd
    }
    return request({
        url: `/ococ/datacapture/openmarket/getFormSamSungInfo`,
        method: 'get',
        params
    })
}

export function getDeviceList(agentId, entrRqstFomNo) {
    let params = {
        dealCd: agentId,
        entrRqstFomNo: entrRqstFomNo
    }
    return request({
        url: `/ococ/datacapture/openmarket/getDiviceModelInfo`,
        method: 'get',
        params
    })
}

export function getApplServiceKindInfo(agentId, entrRqstFomNo ,type) {
    let params = {
        codeType: '',
        dealCd: agentId,
        entrRqstFomNo: entrRqstFomNo
    }
    if(type === 'colors') {
        params.codeType = 'COLR'
    } else if(type === 'choc') {
        params.codeType = 'CHOC'
    } else if(type === 'disc') {
        params.codeType = 'DISC'
    } else if(type === 'duty') { //의무약정
        params.codeType = 'DUTY'
    } else if(type === 'rotr') { //라우터약정
        params.codeType = 'ROTR' 
    } else if(type === 'mcco') { //라우터약정
        params.codeType = 'MCCO' 
    //[ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20261018     
    } else if(type === 'dsnt') { //요금할인약정
        params.codeType = 'DSNT'
    }
    //[ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20261018
    return request({
        url: `/ococ/datacapture/openmarket/getApplServiceKindInfo`,
        method: 'get',
        params
    })
}

export function getPayStyleInfo(ssn, dealCd, entrRqstFomNo, trmMdlCd) {
    let params = {
        custBday: ssn,
        dealCd: dealCd,
        entrRqstFomNo: entrRqstFomNo,
        trmMdlCd: trmMdlCd
    }
    return request({
        url: `/ococ/datacapture/openmarket/getPayStyleInfo`,
        method: 'get',
        params
    })

}

export function getSelfPhonePay(aplcTlno, appfNo) {
    let params = `${aplcTlno.substr(0,3)}0${aplcTlno.substr(3,8)}`
    return request({
        url: `/ococ/datacapture/openmarket/getSelfPhonePayWithAppfNo`,
        method: 'get',
        headers: {
            'aplcTlno': params, //success 010077008060
            'appfNo': appfNo
        }, 
    })
}

// 맘대로 폰 요금제 조회
export function getLssDaydInsLmtList(phoneMdlCd) {
    let params = {
        phoneModelCd: phoneMdlCd,
        hphnLbciClssCd:"HPEW"

    }
    return request({
        url: `/ococ/datacapture/v1/ushop/LssDaydInsLmtList`,
        method: 'get',
        params
    })
}

// privacy센터-동의항목 목록조회 - 통합동의/배치테이블 공통사용
export function getMobileCupsifItemList() {
    let params = {
        cupsifChnlSysId:'UCBMI' //유큐브 모바일 기준
    }
    return request({
        url: `/ococ/datacapture/tps/hmCupsifItemList`,
        method: 'get',
        params
    })
}

// 안면인증(MIS)- 얼굴인증 진행여부 조회
export function getFaceCheckAuthStatus(appfNo, aplcNm, crypRrno) {
    let requestData = { 
        appfNo : appfNo,
        aplcNm : aplcNm,
        crypRrno : crypRrno
    };
    return request({
        url: `/ococ/datacapture/v1/auth/face/status`,
        method: 'post',
        data : requestData
    });
}

// 안면인증(MIS)- 얼굴인증 접속정보 요청
export function requestFaceAuthOneTimeUrl(appfNo, onsaAgrSysCd, autnRqstTlno, agentId, posCd) { 
    
    let requestData = { 
        appfNo: appfNo,             // 신청서번호
        onsaAgrSysCd: onsaAgrSysCd, // 시스템인입구분코드 - OPMK : 오픈마켓 / SAMS : 삼성닷컴 / SALL : 통가상
        autnRqstTlno: autnRqstTlno,  // 얼굴인증요청자 전화번호
        agencyCd: agentId,           // 대리점코드
        posCd: posCd                 // POS코드
    }; 
    
    return request({
        url: '/ococ/datacapture/v1/auth/face/request',
        method: 'post',
        data: requestData
    });
}

// 안면인증(MIS)- 대체인증(2nd디바이스)처리 요청
export function requestFaceAuthAltInfo(appfNo, onsaAgrSysCd, autnRqstTlno, workerId, agentId, posCd, reasonCd) {
    
    let requestData = { 
        appfNo: appfNo,             // 신청서번호
        onsaAgrSysCd: onsaAgrSysCd, // 시스템인입구분코드 - OPMK : 오픈마켓 / SAMS : 삼성닷컴 / SALL : 통가상
        autnRqstTlno: autnRqstTlno,  // 얼굴대체인증대상자 전화번호
        workerId: workerId,    //얼굴대체인증처리자ID
        agencyCd: agentId,  //대리점코드
        posCd: posCd,       //POS코드
        reasonCd: reasonCd  //대체사유코드

    }; 
    
    return request({
        url: '/ococ/datacapture/v1/auth/face/requestAltInfo',
        method: 'post',
        data: requestData
    });
}

// [ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909
export function requestChrgAgmtPlcy(chrgAgmtMmct, mblDcntCd, prodCd) {
    
    let params = { 
        chrgAgmtMmct: chrgAgmtMmct,             // M2M요금약정개월수
        mblDcntCd: mblDcntCd, // 할인코드 
        prodCd: prodCd  // 요금제코드
        
    }; 
    
    return request({
        url: '/ococ/datacapture/v1/mobile/m2m/getChrgAgmtPlcy',
        method: 'get',
        params
    });
}
// [ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909